export class Liste{
    id:any=null;
    matricule:string="";
    nom:string="";
    prenom:string="";
    service:string="";
    telephone:number=0;
    mail:string="";
    nom_patient:string="";
    type_patient:string="";
    be:string="";
    demande:string="";
    bc:string="";
    ordonnance:string="";
    facture:string="";
    notice:string="";
    avis_credit:string="";
    billet_hopital:string="";
    bulletin_naissance:string="";
    acte_mariage:string="";
    acte_deces:string="";
    acte_notoriete:string="";
    cin:string="";
    rib:string="";
    montant:number=0;
    numero_rejet:number=0;
    date_validation:Date;
    

        constructor(){}
}